import { IconButton } from '@mui/material';
import { useAppSelector } from '../app/hooks';
import { RootState } from '../app/store';
import FileSaver from 'file-saver';
import configData from '../configData.json';
import { GetApp } from '@mui/icons-material';

interface Props {
  // Label for file
  label: string;
  // URL part following base API URL, e.g., http://localhost:3001/api/, to the desired route
  //  include no leading '/' and do not include 'api/'
  url: string;
}

const DownloadButton = ({ label, url }: Props) => {
  const token = useAppSelector((state: RootState) => state.auth.token);
  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    const resp = await fetch(configData.SERVER_URL + url, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/pdf',
      },
    });
    const blob = await resp.blob();
    FileSaver.saveAs(blob, label);
  };
  return (
    <IconButton
      onClick={handleClick}
      color='primary'
      aria-label='download'
      size='large'
    >
      <GetApp />
    </IconButton>
  );
};

export default DownloadButton;
